<app-vinavon-button>
    <button (click)="editWorkingHours()" [disabled]="!(allowModifyHours$ | async)" mat-raised-button>
        <mat-icon>more_time</mat-icon>
        {{ "Zeit bearbeiten" }}
    </button>

    <button (click)="delWorkingHours()" [disabled]="!(allowModifyHours$ | async)" mat-raised-button>
        <mat-icon>auto_delete</mat-icon>
        {{ "Zeit löschen" }}
    </button>
</app-vinavon-button>

<mat-card appearance="outlined" style="flex: 1;
    height: auto;
    display: flex;
    overflow: hidden;">
    <mat-tab-group (selectedTabChange)="timeTabChange($event)" style="flex: 1; overflow: hidden;">
        <mat-tab label="Auftragszeiten">
            <ejs-grid #gridZeiten (rowDeselected)="rowDeselected($event)" (rowSelected)="rowSelected($event)" [allowSorting]="true" [dataSource]="zeitZeilen$ | async" [showColumnChooser]='true'
                      [toolbar]='toolbarOptions' style="flex: 1; overflow: auto; position: static;">
                <e-columns>
                    <e-column [showInColumnChooser]='false' [visible]="false" field="servicePosID" headerText="ID" width="0"></e-column>
                    <e-column [format]="{type: 'date', format:'dd.MM.yyyy'}" field="datum" headerText="Datum" maxWidth='80' minWidth='80' textAlign="Right" width='80'></e-column>
                    <e-column field="mitarbeiter" headerText="Mitarbeiter" textAlign="Left" width="140"></e-column>
                    <e-column field="auftrag" headerText="Auftrag" minWidth="150" textAlign="Left"></e-column>
                    <e-column field="zeiten" headerText="Start/Ende" textAlign="Left" width="85"></e-column>
                    <e-column field="zeitMenge" headerText="[h]" textAlign="Left" width="45"></e-column>
                    <e-column field="arbeitsbezeichnung" headerText="Tätigkeit" textAlign="Left"></e-column>
                    <e-column field="spesenArt" headerText="Spesenart" hideAtMedia='(min-width: 1200px)' textAlign="Left"></e-column>
                    <e-column field="spesenMenge" headerText="Spesenmenge" hideAtMedia='(min-width: 1200px)' textAlign="Left"></e-column>
                    <e-column field="arbeitsort" headerText="Arbeitsort" textAlign="Left"></e-column>
                    <e-column field="notizen" headerText="Notiz" hideAtMedia='(min-width: 1200px)' textAlign="Left"></e-column>
                    <e-column field="kulanz" headerText="Kulanz" textAlign="Right" width="65">
                        <ng-template #template let-data>
                            <img alt="img" src="/assets/images/{{ imgSrc(data.kulanz) }}" style="width: 16px; height: 16px; float: right;"/>
                        </ng-template>
                    </e-column>
                </e-columns>
            </ejs-grid>
        </mat-tab>
        <mat-tab label="Tagesübersicht">
            <div style="display: flex; justify-content: center; align-items: center; padding-bottom: 2em">
                <button (click)="dayBack($event)" mat-button>
                    <mat-icon>arrow_back_ios</mat-icon>
                </button>
                <mat-form-field class="date">
                    <mat-label>
                        {{ "MAIN_APP_SERVICE_APP.datum" | translate }}
                    </mat-label>
                    <input #dayref (dateChange)="onDayDateChange(dayref.value)" [formControl]="dayDate" [matDatepicker]="picker" matInput/>
                    <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
                <button (click)="dayForward($event)" mat-button>
                    <mat-icon>arrow_forward_ios</mat-icon>
                </button>
            </div>
            <ejs-grid #gridTagesZeiten (actionComplete)="complete($event)" (rowDeselected)="rowDeselected($event)" (rowSelected)="rowSelectedDay($event)" [allowFiltering]="true" [allowSorting]="true"
                      [dataSource]="zeitZeilen$ | async" [showColumnChooser]='true' [sortSettings]="sortOptions" [toolbar]='toolbarOptions' style="flex: 1; overflow: auto; position: static;">
                <e-columns>
                    <e-column [showInColumnChooser]='false' [visible]="false" field="servicePosID" headerText="ID" width="0"></e-column>
                    <e-column [format]="{type: 'date', format:'dd.MM.yyyy'}" field="datum" headerText="Datum" textAlign="Right" width="80"></e-column>
                    <e-column field="mitarbeiter" headerText="Mitarbeiter" textAlign="Left" width="140"></e-column>
                    <e-column field="auftrag" headerText="Auftrag" textAlign="Left">
                        <ng-template #template let-data>
                            <span style="display: flex; align-items: center; width: 100%; justify-content: space-between;">
                                {{ data.auftrag }}
                                <mat-icon *ngIf="data.isTimeEntry">timer</mat-icon>
                            </span>
                        </ng-template>
                    </e-column>
                    <e-column field="zeiten" headerText="Start/Ende" textAlign="Left" width="130"></e-column>
                    <e-column field="zeitMenge" headerText="Gearbeitet [h]" textAlign="Left" width="120"></e-column>
                    <e-column field="arbeitsbezeichnung" headerText="Tätigkeit" textAlign="Left"></e-column>
                    <e-column field="spesenArt" headerText="Spesenart" textAlign="Left"></e-column>
                    <e-column field="spesenMenge" headerText="Spesenmenge" textAlign="Left"></e-column>
                    <e-column field="arbeitsort" headerText="Arbeitsort" textAlign="Left"></e-column>
                    <e-column field="notizen" headerText="Notiz" textAlign="Left"></e-column>
                    <e-column field="kulanz" headerText="Kulanz" textAlign="Center">
                        <ng-template #template let-data>
                            <img alt="img" src="/assets/images/{{ imgSrc(data.kulanz) }}" style="width: 16px; height: 16px"/>
                        </ng-template>
                    </e-column>
                </e-columns>
                <e-aggregates>
                    <e-aggregate>
                        <e-columns>
                            <e-column columnName="zeiten" type="Custom">
                                <ng-template #footerTemplate let-data>{{
                                        "MAIN_APP_SERVICE_APP.aufwandTotal" | translate
                                    }}:
                                </ng-template>
                            </e-column>
                            <e-column [customAggregate]="customAggregateFn" columnName="zeitMenge" type="Custom">
                                <ng-template #footerTemplate let-data>{{ data.Custom }}
                                </ng-template>
                            </e-column>
                        </e-columns>
                    </e-aggregate>
                </e-aggregates>
            </ejs-grid>
        </mat-tab>
        <mat-tab label="Zeitkontrolle">
            <div style="display: flex; flex-direction: column; height: 100%">
                <div style="display: flex; justify-content: center;">
                    <mat-form-field appearance="outline" style="width: auto;">
                        <mat-label>{{ "MAIN_APP_SERVICE_APP.dayFilterSelection.label" | translate }}</mat-label>
                        <mat-select (selectionChange)="changeFilter($event)" [(value)]='filtervalue'>
                            <mat-option value="Alle Tage">{{ "MAIN_APP_SERVICE_APP.dayFilterSelection.allDays" | translate }}</mat-option>
                            <mat-option value="Abgeschlossene Tage">{{ "MAIN_APP_SERVICE_APP.dayFilterSelection.doneDays" | translate }}</mat-option>
                            <mat-option value="Offene Tage">{{ "MAIN_APP_SERVICE_APP.dayFilterSelection.openDays" | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <span style="display: flex; align-items:center;">
						<img (click)="saveFilterSettings()" alt="save" src="../../assets/images/save2.png" style="margin: 5px;height:24px"/>

					</span>
                </div>
                <ejs-grid #gridZeitkontrolle (rowDeselected)="rowDeselected($event)" (rowSelected)="rowSelectedControl($event)" [allowGrouping]="true" [allowSorting]="true"
                          [dataSource]="(zeitKontrollZeilen$ | async)" [groupSettings]="groupSettings" [showColumnChooser]='true' [sortSettings]="sortOptions" [toolbar]='toolbarOptions' locale="de-CH"
                          style="flex: 1; overflow: auto; position: static;">
                    <e-columns>
                        <e-column [showInColumnChooser]='false' [visible]="false" field="servicePosID" headerText="ID" width="0"></e-column>
                        <e-column [showInColumnChooser]='false' [visible]="false" field="datumStrCH" headerText="Datum CH" textAlign="Right" width="100"></e-column>
                        <e-column [showInColumnChooser]='false' [valueAccessor]='valueAccess' [visible]="false" field="datumStrEN" headerText="Datum EN" textAlign="Right" width="100">
                            <ng-template #groupSettingsCaptionTemplate let-data>{{ formatDate(data) }}</ng-template>
                        </e-column>
                        <e-column [format]="{type: 'date', format:'dd.MM.yyyy'}" [showInColumnChooser]='false' field="datum" headerText="Datum" textAlign="Right" width="100"></e-column>
                        <e-column field="mitarbeiter" headerText="Mitarbeiter" textAlign="Left" width="140"></e-column>
                        <e-column field="auftrag" headerText="Auftrag" textAlign="Left">
                            <ng-template #template let-data>
                                <span style="display: flex; align-items: center; width: 100%; justify-content: space-between;">
                                    {{ data.auftrag }}
                                    <mat-icon *ngIf="data.isTimeEntry">timer</mat-icon>
                                </span>
                            </ng-template>
                        </e-column>
                        <e-column field="zeiten" headerText="Start/Ende" textAlign="Left" width="130"></e-column>
                        <e-column field="zeitMenge" headerText="Gearbeitet [h]" textAlign="Left" width="120"></e-column>
                        <e-column field="arbeitsbezeichnung" headerText="Tätigkeit" textAlign="Left"></e-column>
                        <e-column field="spesenArt" headerText="Spesenart" textAlign="Left"></e-column>
                        <e-column field="spesenMenge" headerText="Spesenmenge" textAlign="Left"></e-column>
                        <e-column [visible]="false" field="arbeitsort" headerText="Arbeitsort" textAlign="Left"></e-column>
                        <e-column [visible]="false" field="notizen" headerText="Notiz" textAlign="Left"></e-column>
                        <e-column field="kulanz" headerText="Kulanz" textAlign="Center">
                            <ng-template #template let-data>
                                <img alt="img" src="/assets/images/{{ imgSrc(data.kulanz) }}" style="width: 16px; height: 16px; display: inline;"/>
                            </ng-template>
                        </e-column>
                        <e-column field="uploaded" headerText="Status" textAlign="Center">
                            <ng-template #template let-data>
                                <img *ngIf="data.uploaded" alt="img" src="/assets/images/flash.png" style="width: 16px; height: 16px; display: inline;"/>
                            </ng-template>
                        </e-column>
                    </e-columns>
                    <e-aggregates>
                        <e-aggregate>
                            <e-columns>
                                <e-column field="zeitMenge" type="Sum">
                                    <ng-template #groupFooterTemplate let-data>Total: {{ data.Sum }}
                                    </ng-template>
                                </e-column>
                                <e-column [customAggregate]="customAggregateLock" field="kulanz" type="Custom">
                                    <ng-template #groupFooterTemplate let-data>
                                        <button (click)="changeDayControlState(data.key)" mat-icon-button>
                                            <mat-icon>{{ data.Custom }}</mat-icon>
                                        </button>
                                    </ng-template>
                                </e-column>
                            </e-columns>
                        </e-aggregate>
                    </e-aggregates>
                </ejs-grid>
            </div>
        </mat-tab>
    </mat-tab-group>
</mat-card>

